import { useState } from "react";
import {
  Flex,
  Input,
  Button,
  InputGroup,
  Stack,
  InputLeftElement,
  chakra,
  Box,
  Avatar,
  FormControl,
  InputRightElement,
  useToast,
  Text,
  Select,
} from "@chakra-ui/react";
import {
  FaPhoneAlt,
  FaUserAlt,
  FaLock,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import { useForm } from "../helpers/useForm";

const CFaUserAlt = chakra(FaUserAlt);
const CFPhoneAlt = chakra(FaPhoneAlt);
const CFaLock = chakra(FaLock);

export default function Register() {
  const [showPassword, setShowPassword] = useState(false);
  const { values, handleValueChange } = useForm();
  const navigate = useNavigate();
  const toast = useToast();
  const phoneNumberRegexError = !/^[0-9]{9,13}$/.test(values.phoneNumber);

  function handleRegister(e) {
    e.preventDefault();
    if (phoneNumberRegexError) return;
    baseService.post(
      config.services.user.create,
      values,
      (res) => {
        toast({
          position: "top",
          description: res.data.message,
          status: "success",
          duration: 5000,
          size: "md",
          isClosable: true,
        });
        navigate("/profile");
      },
      (error) => {
        toast({
          position: "top",
          description: error.data.message,
          status: "error",
          duration: 5000,
          size: "md",
          isClosable: true,
        });
      }
    );
  }

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="var(--page-height)"
    >
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <Avatar bg="blue.500" />
        <Box>
          <form onSubmit={handleRegister}>
            <Stack
              spacing={4}
              p="1rem"
              backgroundColor="whiteAlpha.900"
              boxShadow="lg"
            >
              <FormControl isRequired>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<CFaUserAlt color="gray.300" />}
                  />
                  <Input
                    fontSize={14}
                    placeholder="Nama"
                    name="name"
                    onChange={handleValueChange}
                  />
                </InputGroup>
              </FormControl>
              <FormControl isRequired>
                <Select
                  fontSize="sm"
                  placeholder="Gender"
                  name="gender"
                  onChange={handleValueChange}
                >
                  <option value="laki-laki">Laki-laki</option>
                  <option value="perempuan">Perempuan</option>
                </Select>
              </FormControl>
              <FormControl isRequired>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<CFPhoneAlt color="gray.300" />}
                  />
                  <Input
                    fontSize={14}
                    placeholder="Nomor handphone"
                    name="phoneNumber"
                    onChange={handleValueChange}
                  />
                </InputGroup>
                <Text fontSize={13} color="gray.500">
                  contoh: 08123456789
                </Text>
                {phoneNumberRegexError && values.phoneNumber && (
                  <Text fontSize={13} color="red.500">
                    Nomor handphone tidak valid.
                  </Text>
                )}
              </FormControl>
              <FormControl isRequired>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    color="gray.300"
                    children={<CFaLock color="gray.300" />}
                  />
                  <Input
                    fontSize={14}
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    onChange={handleValueChange}
                  />
                  <InputRightElement
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {!values.password ? null : showPassword ? (
                      <FaEyeSlash />
                    ) : (
                      <FaEye />
                    )}
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <Button
                borderRadius={0}
                type="submit"
                variant="solid"
                colorScheme="blue"
                width="full"
                fontSize="sm"
              >
                Daftar
              </Button>
            </Stack>
          </form>
        </Box>
        <Text fontSize="xs" w="100%" textAlign="end" color="gray">
          Sudah punya akun?{" "}
          <Link to="/profile" style={{ color: "blue" }}>
            Masuk
          </Link>
        </Text>
      </Stack>
    </Flex>
  );
}
